import React from 'react'
import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { Stack, XStack, colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

const ZetForMeLoader = () => {
  return (
    <MotiView
      transition={{
        type: 'timing',
      }}
      style={[styles.container, styles.padded]}
      animate={{ backgroundColor: colors.neutral.white100 }}
    >
      <XStack className="space-x-3 pb-3">
        <Stack className="flex-1">
          <Skeleton colorMode={'light'} width={'100%'} height={80} />
        </Stack>
        <Stack className="flex-1">
          <Skeleton colorMode={'light'} width={'100%'} height={80} />
        </Stack>
        <Stack className="flex-1">
          <Skeleton colorMode={'light'} width={'100%'} height={80} />
        </Stack>
        <Stack className="flex-1">
          <Skeleton colorMode={'light'} width={'100%'} height={80} />
        </Stack>
      </XStack>
      <Skeleton colorMode={'light'} width={'100%'} height={30} />
    </MotiView>
  )
}

export default ZetForMeLoader

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  padded: {
    padding: 16,
  },
})
